import Header from '../../../shared/Header';
import { useTranslation } from 'react-i18next';
import { Stack } from '../../../shared/layouts';
import Card from '../../../shared/Card';
import OverviewDetailRow from '../../../shared/OverviewDetailRow';
import AdvisorDetails from '../../../shared/AdvisorDetails';
import { currencyFormatter } from '@dnhb/formatters';
import FileAttachmentButton from '../../../shared/FileAttachmentButton';
import LonelyPlaceholder from '../../../shared/LonelyPlaceholder';
import { findTranslation } from '../../../../utils/helpers'
import { getPeriodOptions } from '../../../../utils/constants';

export default ({ title, insuranceData, isMinDesktop, connectedFiles }) => {
  const { t } = useTranslation();
  const {
    uuid,
    type,
    insuree,
    premium,
    coverages = [],
    start_date: policy_start_date,
    product_name,
    coverage_area,
    policy_number,
    expiration_date,
    prolongation_date,
    object_description,
    product_description,
    policy_duration_in_months,
    advisor = {},
  } = insuranceData || {};
  const insuranceFiles = connectedFiles?.[uuid] || [];

  return (
    <Card fontSize={isMinDesktop ? 'm' : 's'}>
      <Stack space={isMinDesktop ? 'l' : 'm'}>
        <Header
          title={title}
          variant="section"
          fontSize={isMinDesktop ? 'l' : 's'}
        />
        <div>
          <b>{t('Polis') + ':'}</b>
          <Stack space={'none'} divider={'default'}>
            <OverviewDetailRow
              descriptor={t('Verzekerde')}
              value={insuree}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Dekkingsgebied')}
              value={coverage_area}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Soort verzekering')}
              value={type}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Product')}
              value={product_name}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Polisnummer')}
              value={policy_number}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Premie')}
              value={
                premium?.amount ? currencyFormatter(premium?.amount) : null
              }
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Betaaltermijn')}
              value={
                premium?.period
                  ? findTranslation(premium.period, getPeriodOptions())
                  : null
              }
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Ingangsdatum')}
              value={policy_start_date}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Hoofdvervaldatum')}
              value={expiration_date}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Polis looptijd')}
              value={
                policy_duration_in_months
                  ? t(`{{years}} jaar`, {
                      years: Math.floor(policy_duration_in_months / 12),
                    })
                  : null
              }
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Laatste prolongatie')}
              value={prolongation_date}
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Omschrijving')}
              value={product_description}
              textArea
              hideIfEmpty
            />
            <OverviewDetailRow
              descriptor={t('Object')}
              value={object_description}
              textArea
              hideIfEmpty
            />
            <LonelyPlaceholder />
          </Stack>
        </div>
        {coverages?.length > 0 &&
          coverages.map(
            ({ name, own_risk, coverage_amount, family_composition }) => (
              <div key={name}>
                <b>{`${t('Dekking')} ${name}`}</b>
                <Stack space={'none'} divider={'default'}>
                  <OverviewDetailRow
                    descriptor={t('Verzekerd bedrag')}
                    value={
                      coverage_amount
                        ? currencyFormatter(coverage_amount)
                        : null
                    }
                    hideIfEmpty
                  />
                  <OverviewDetailRow
                    descriptor={t('Eigen risico bedrag')}
                    value={own_risk ? currencyFormatter(own_risk) : null}
                    hideIfEmpty
                  />
                  <OverviewDetailRow
                    descriptor={t('Gezinssamenstelling')}
                    value={family_composition}
                    textArea
                    hideIfEmpty
                  />
                </Stack>
              </div>
            )
          )}
        {Object.keys(advisor).length > 0 && <AdvisorDetails {...advisor} />}
        {insuranceFiles?.length > 0 && (
          <div>
            <b>{t('Document(en)') + ':'}</b>
            <Stack space={'s'} mt={'s'}>
              {insuranceFiles.map(({ name, download_url }) => (
                <FileAttachmentButton
                  key={name}
                  fileName={name}
                  fileUrl={download_url}
                />
              ))}
            </Stack>
          </div>
        )}
      </Stack>
    </Card>
  );
};
